// extracted by mini-css-extract-plugin
export default {"Ribbon":"ribbon_Ribbon__5BKoP"};